import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { CareerId } from '@common/const/catalog/career';
import { getFullName } from '../lib';

/**
 * create json-ld schema
 * @url https://schema.org/Person
 * @param declination transform careerId to name
 * @param optionGetter transform optionId to name
 * @param resume
 */
export const createPersonSchema = (
  declination: (number: number, careerId: CareerId) => string,
  optionGetter: (o: { id: number }) => string,
  resume: CatalogItemViewModel & Required<Pick<CatalogItemViewModel, 'clientProfile' | 'city'>>,
) => ({
  '@type': 'Person',
  name: getFullName(resume.clientProfile),
  description: resume.translation?.description,
  jobTitle: declination(1, resume.careerId),
  knowsAbout: resume.options.map(optionGetter).filter(Boolean),
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'Россия',
    addressLocality: resume.city.translation.name,
    addressRegion: resume.city.translation.regionName,
  },
});
